import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "workflows",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-intelligence-automation" */ "Admissions/features/IntelligenceAutomation/components/Workflows"
    ).then(m => m.default)
  ),
});
